'use strict';

var jsonldSignaturesBbs = require('@mattrglobal/jsonld-signatures-bbs');

const proofTypeMapping = {
  BbsBlsSignature2020: jsonldSignaturesBbs.BbsBlsSignature2020,
  BbsBlsSignatureProof2020: jsonldSignaturesBbs.BbsBlsSignatureProof2020
};

exports.proofTypeMapping = proofTypeMapping;
